import React from 'react';
import { TrendUp } from '@phosphor-icons/react';

const StatCard = ({ label, value, trend, note, icon: Icon }) => {
  return (
    <div className="bg-[#13161e] border border-[#2a2e3d] rounded-md p-4 md:p-6 hover:border-[#4f9eff]/50 transition-colors" data-testid={`stat-card-${label.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="flex items-start justify-between mb-2 md:mb-4">
        <div className="text-[#8b949e] font-['IBM_Plex_Mono'] text-[10px] md:text-xs uppercase tracking-wider leading-tight">{label}</div>
        {Icon && <Icon size={16} className="text-[#4f9eff] flex-shrink-0 md:w-5 md:h-5" weight="duotone" />}
      </div>
      <div className="text-white font-['Fraunces'] text-xl md:text-3xl font-bold mb-1 md:mb-2 truncate" data-testid={`stat-value-${label.toLowerCase().replace(/\s+/g, '-')}`}>{value}</div>
      {trend && (
        <div className="flex items-center gap-1 text-[#00d68f] font-['IBM_Plex_Mono'] text-[10px] md:text-xs">
          <TrendUp size={12} weight="bold" />
          +{trend}% vs mes anterior
        </div>
      )}
      {note && (
        <div className="text-[#8b949e] font-['Mulish'] text-[10px] md:text-xs mt-1 md:mt-2 truncate">{note}</div>
      )}
    </div>
  );
};

export default StatCard;